import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Section";
import { KINGSMOSS_ONE_OFF, KINGSMOSS_URL, trackKingsmossClick } from "@/lib/referral";

export const KingsmossSection = () => (
  <section className="border-t border-[#1d1d1d] bg-[#0b0b0b] py-16 sm:py-20" data-testid="home-kingsmoss-section">
    <div className="lc-container">
      <Reveal className="grid items-center gap-8 rounded-3xl border border-[#262626] bg-[#101010] p-8 sm:p-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-[#F7F5F0]">Looking for a one-off firewood order?</h2>
          <p className="mt-4 text-base text-[#A1A1AA]">Not ready for a monthly subscription?</p>
          <p className="mt-2 text-base text-[#A1A1AA]">Visit Kingsmoss Logs NI for individual firewood orders and other solid fuels.</p>
          <p className="mt-2 text-sm text-[#8a8a8a]">WeeLogRun works with Kingsmoss Logs NI to bring convenient monthly firewood deliveries to homes across Newtownabbey and surrounding areas.</p>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <a href={KINGSMOSS_ONE_OFF} target="_blank" rel="noopener" onClick={() => trackKingsmossClick("home_one_off")}
            className="lc-btn-ghost inline-flex !py-3" data-testid="home-kingsmoss-link">
            Visit Kingsmoss Logs NI <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export const KingsmossFooterLink = () => (
  <p>
    One-off firewood orders:{" "}
    <a href={KINGSMOSS_URL} target="_blank" rel="noopener" onClick={() => trackKingsmossClick("footer")}
      className="text-[#F7F5F0]/70 underline-offset-4 transition-colors hover:text-[#FF6A00] hover:underline" data-testid="footer-kingsmoss-link">
      Kingsmoss Logs NI
    </a>
  </p>
);
